import { DocType } from '../enums';

export class DocumentViewDialogDataInterface {
  documentNumber: string;
  minDateTime?: string;
  maxDateTime?: string;
  documentType: DocType;
}
